module.exports = __webpack_public_path__ + "img/ec.4dae761c.svg";